if (!customElements.get('quick-add-variations')) {
  customElements.define(
    'quick-add-variations',
    class QuickAddVariations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        // Mobile/tablet (no hover pointer): use fixed panel behavior + add a close button
        if (window.matchMedia('(max-width: 1365px)').matches) {
          this.classList.add('quick-add-variations--fixed');
          const closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.className = 'quick-add-variations__close';
          closeBtn.innerHTML = '&times;';
          closeBtn.addEventListener('click', () => {
            this.style.display = 'none';
            document.body.classList.remove('quick-add-open');
          });
          this.appendChild(closeBtn);
        }
        // END fixed panel behavior for touch devices

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const oButtons = this.querySelectorAll('button.option');

        // if (oButtons.length <= 1) {
        //   const mobileQuickAdd = this.parentElement?.querySelector('.quick-add');
        //   if (mobileQuickAdd) mobileQuickAdd.remove();
        //   this.remove();
        //   return;
        // }

        const sButton = this.querySelector('button.quick-add__submit');
        const popupCartErr = document.querySelector('#cart-popup');

        // Bind the global click handler only once (event delegation)
        if (!window.__qavBoundOnce) {
          window.__qavBoundOnce = true;

          document.addEventListener('click', function (e) {
            // SHOW: clicked on a trigger button
            const btn = e.target.closest('button[data-trigger-variations]');
            if (btn) {
              // Ignore slick cloned slides
              if (btn.closest('.slick-cloned')) return;

              // Stop other handlers so this doesn't get canceled by other listeners
              if (e.stopImmediatePropagation) e.stopImmediatePropagation();
              e.stopPropagation();
              e.preventDefault();

              const pid = btn.getAttribute('data-trigger-variations');
              // Prefer section id from the button; fallback to nearest wrapper with data-section-id
              const sectionId =
                btn.getAttribute('data-section-id') ||
                (btn.closest('[data-section-id]') && btn.closest('[data-section-id]').getAttribute('data-section-id'));

              // Match panel by productId + sectionId to avoid collisions across sections
              const panelSelector = sectionId
                ? `quick-add-variations[data-product-id="${pid}"][data-section-id="${sectionId}"]`
                : `quick-add-variations[data-product-id="${pid}"]`;

              const panel = document.querySelector(panelSelector);

              if (!panel) {
                console.warn('[QAV] Panel not found for', { pid, sectionId });
                return;
              }

              // Move panel to <body> to avoid stacking/overflow issues
              document.body.appendChild(panel);

              // Hide all other panels before showing current
              document.querySelectorAll('quick-add-variations').forEach(el => (el.style.display = 'none'));

              // Show current panel
              panel.style.display = 'flex';
              document.body.classList.add('quick-add-open');
              return;
            }

            // HIDE: clicked outside any panel and not on a trigger
            const insidePanel = e.target.closest('quick-add-variations');
            const isTrigger = e.target.closest('button[data-trigger-variations]');
            if (insidePanel || isTrigger) return;

            document.querySelectorAll('quick-add-variations').forEach(el => (el.style.display = 'none'));
            document.body.classList.remove('quick-add-open');
          });
        }

        // Add to cart via size option buttons
        oButtons.forEach(button => {
          button.addEventListener('click', event => {
            event.stopPropagation();
            if (sButton) sButton.classList.add('button-adding');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const variantId = button.getAttribute('data-variant-id');

            const formData = new FormData();
            formData.append('id', variantId);

            if (this.cart) {
              formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }

            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
              .then(response => response.json())
              .then(response => {
                if (response.status) {
                  // Surface error and close the panel
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: variantId,
                    errors: response.errors || response.description,
                    message: response.message
                  });
                  this.style.display = 'none';
                  document.body.classList.remove('quick-add-open');
                  if (sButton) sButton.classList.remove('button-adding');

                  // Show small popup error on mobile
                  if (popupCartErr) {
                      popupCartErr.querySelector('p').innerHTML = response.message;
                      popupCartErr.style.display = 'block';
                      setTimeout(() => (popupCartErr.style.display = 'none'), 3000);
                  }

                  return;
                } else if (!this.cart) {
                  // No cart drawer/notification → fallback to cart page
                  window.location = window.routes.cart_url;
                  return;
                }

                // Success: update cart sections and close the panel
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: variantId,
                  cartData: response
                });
                this.cart.renderContents(response);
                this.style.display = 'none';
                document.body.classList.remove('quick-add-open');
                if (sButton) sButton.classList.remove('button-adding');
                console.log('269');
              })
              .catch(error => {
                  console.log('[QAV] cart_add error', error);
                  this.style.display = 'none';
                  document.body.classList.remove('quick-add-open');
                  if (sButton) sButton.classList.remove('button-adding');
                  console.log('276');
              })
              .finally(() => {
                this.cart && this.cart.classList.contains('is-empty') && this.cart.classList.remove('is-empty');
                console.log('279');
              });
          });
        });
      }
    }
  );
}
